import { createStyles } from 'antd-style'

import { PriceIndexChartDatePicker } from '../components/DatePicker'
import { PriceIndexChartDiagram } from '../components/Diagram'
import { PriceIndexChartKindSelect } from '../components/KindSelect'
import { PriceIndexChartTypeSwitch } from '../components/TypeSwitch'

import { PriceIndexChartCoreProps } from './interface'

const useStyles = createStyles(({ token }) => ({
  container: {
    height: '100%',
    width: '100%',
    overflow: 'hidden',
    paddingBlock: token.paddingXS,
    paddingInline: token.paddingXS,
    display: 'flex',
    flexFlow: 'column',
    gap: token.marginXS
  },
  filter: {
    display: 'grid',
    gridTemplateColumns: 'auto 1fr auto',
    gap: token.marginXS
  },
  diagram: {
    flex: 1,
    overflow: 'hidden'
  }
}))

export const PriceIndexChartCore = ({
  className,
  style,
  styles: externalStyles,
  title,
  ...diagramProps
}: PriceIndexChartCoreProps) => {
  const { cx, styles } = useStyles()

  return (
    <div className={cx(styles.container, className)} style={style}>
      {title}
      <div className={styles.filter}>
        <PriceIndexChartKindSelect style={externalStyles?.kindSelect} />
        <PriceIndexChartDatePicker />
        <PriceIndexChartTypeSwitch />
      </div>
      <PriceIndexChartDiagram className={styles.diagram} {...diagramProps} />
    </div>
  )
}
